/**
 *
 * Asynchronously loads the component for AgentsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const AgentsPage = lazyLoad(
  () => import('./index'),
  module => module.AgentsPage,
);
